import { useIntl } from "./intl-context.js";

/**
 * Hook to get the current locale.
 * Returns the locale from IntlContext if available, otherwise falls back to "en-US".
 */
export function useLocale(): string {
  const intl = useIntl();
  return intl?.locale ?? "en-US";
}
